// @vendors
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');
const reduce = require('lodash/collection/reduce');
const find = require('lodash/collection/find');
const moment = require('moment');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const signaturePatternActions = require('actions/signaturePattern');
const  { showMemories } = require( 'commonsUtilities/showMemoriesHelper');

// @actions
const investmentFundsActions = require('actions/investmentFunds');

// @utils
const PersonalDataHelper = require('utilities/personalDataHelper');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const translateExantCostKey = require('utilities/translationExantCost');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const usd = require('utilities/usd');


// @constants
const actionTypes = require('constants/actionTypes');
const errorActions = require('actions/brokerError');
const {
    ACCOUNT_INTERVENTION_OWNER,
    BROKER_EMPLOYEE_ID,
    BROKER_REIMBURSE_FUND_TOTAL,
    EURO_TEXT,
    FIRST_STEP,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS,
    BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE,
    BROKER_INTERNAL_TRANSFER_NEW_FUND,
    BROKER_INTERNAL_TRANSFER_EXISTING_FUND,
    BROKER_MIFID_VERSION_2,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_ORDER_TYPE_BUY,
    BROKER_PRODUCT_TYPE_FUNDS_ES,
    SECOND_STEP,
    WIZARD_SECOND_STEP,
    INTERVENER_TYPE_TITULAR,
    BROKER_MIFID_FUNDS_TRANSFER_SHARES_DECIMALS,
    BROKER_MIFID_FUNDS_TRANSFER_AMOUNT_DECIMALS,
    BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER,
    API_CHANNEL,
    PERIODICITY_DOCUMENT_SERVICE
} = require('constants/index');
const { COUNTRIES_CODES: { PT } } = require('constants/countries');



// @ Contact Center constants
const contactCenterActionTypes = require('constants/contactCenter/actionTypes');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

const setVisibleStep = step => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillLeave = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_WILL_LEAVE
});


//TODO: Add a confirmation when a user click con Cancel.
const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const createValidateStepAction = (step, data) => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_VALIDATE_STEP,
    payload: {
        step,
        data
    }
});

const validateSecondStep = (dispatch, getState) => {
    const immSteps = getState().brokerInternalTransferFunds.get('steps');
    const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
    const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
    const onlyOriginContribution = originHasContribution && !destinationHasContribution;
    const stepNumber = onlyOriginContribution ? 3 : WIZARD_SECOND_STEP;
    const indexNumber = onlyOriginContribution ? 2 : SECOND_STEP
    const disclaimerChecked = getState().brokerInternalTransferFunds.getIn([ 'steps', indexNumber, 'disclaimerChecked' ]);
    dispatch(createValidateStepAction(stepNumber, {
        valid: disclaimerChecked,
        disclaimerInvalid: !disclaimerChecked
    }));
};

const validateContactCenterSecondStep = (dispatch, getState) => {
    const immSteps = getState().brokerInternalTransferFunds.get('steps');
    const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
    const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
    const onlyOriginContribution = originHasContribution && !destinationHasContribution;
    const indexNumber = onlyOriginContribution ? 2 : SECOND_STEP
    const selectedYesNoOption = getState().brokerInternalTransferFunds.getIn([ 'steps', indexNumber, 'selectedYesNoOption' ]);
    const emailHasBeenSent = getState().preContractualMail.get('mailSent');

    dispatch(createValidateStepAction(WIZARD_SECOND_STEP, {
        valid: selectedYesNoOption === SELECTED_VALUES.YES && emailHasBeenSent,
        yesNoOptionInvalid: selectedYesNoOption !== SELECTED_VALUES.YES,
        mailInvalid: !emailHasBeenSent
    }));
};

const validateStep = (step) => (dispatch, getState) => {
    const immSteps = getState().brokerInternalTransferFunds.get('steps');
    const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
    const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
    const onlyOriginContribution = originHasContribution && !destinationHasContribution;
    const stepNumber = onlyOriginContribution ? 3 : WIZARD_SECOND_STEP;
    if (step === stepNumber) {
        if (__CONTACT_CENTER__) {
            validateContactCenterSecondStep(dispatch, getState);
        } else {
            validateSecondStep(dispatch, getState);
        }
    } else {
        dispatch(createValidateStepAction(step));
    }
};

const changeType = type => (dispatch, getState) => {
    const step1 = getState().brokerInternalTransferFunds.getIn(['steps', 0]);
    const hasContributionStep = getState().brokerInternalTransferFunds.getIn(['steps', 1, 'hasPreviousContributions']);
    dispatch(changeTransferType(type))
    if (type === 'partial' && hasContributionStep) {
        dispatch(removeContributionStep())
    } else if (type === 'total' && !hasContributionStep) {
        const originContributionDetails = step1.get('originContributionDetails');
        if (originContributionDetails) {
            dispatch(setOriginContributionFundStep(originContributionDetails))
        }
    }
};

const changeTransferType = type => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_TYPE,
    payload: {
        type
    }
});


const setPartialTransferType = type => ({
    type: actionTypes.BROKER_INTERNAL_TRANSFER_FUNDS_SET_PARTIAL_TRANSFER_TYPE,
    payload: {
        type
    }
});

const changeReadChecked = checked => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_CHECKBOX,
    payload: {
        checked
    }
});

const setAmount = (amount, partialType) => ({
    type: actionTypes.BROKER_INTERNAL_TRANSFER_FUNDS_SET_PARTIAL_INPUT_VALUE,
    payload: {
        amount,
        partialType
    }
});

const setAproxAmountParticipations = amountParticipations => (dispatch, getState) => {
  const immInvestmentFunds = getState().investmentFunds;
  const immInternalTransfer = getState().brokerInternalTransferFunds;
  const immInvestmentFundList = immInvestmentFunds.get('list');
  const contractCode = immInternalTransfer.getIn([
    'steps',
    0,
    'originContributionDetails',
    'contractCode',
  ]);
  const immInvestmentFund = immInvestmentFundList.find(fund => {
    if (fund.getIn(['contrato', 'numerodecontrato']) === contractCode) {
      return fund;
    }
  });
  const amount = immInvestmentFund.getIn(['saldo2Euros', 'valorliquidativo']);
  const currency = immInvestmentFund.getIn(['saldo2Euros', 'divisa']);
  const aproxAmountValue = `${(amount * amountParticipations).toFixed(2)} ${currency}`;

  dispatch({
    type: actionTypes.BROKER_INTERNAL_TRANSFER_FUNDS_SET_APROX_AMOUNT_PARTICIPATIONS,
    payload: {
      aproxAmountParticipations: aproxAmountValue,
    },
  });
};

const setOriginFund = (fundId, linkedToRobo, hasContribution, originContributionDetails) => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_ORIGIN_FUND_ID,
    payload: {
        fundId,
        linkedToRobo,
        hasContribution,
        originContributionDetails
    }
});

const setDestinationFund = (fundId, linkedToRobo, hasContribution, destinationContributionDetails) => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_DESTINATION_FUND_ID,
    payload: {
        fundId,
        linkedToRobo,
        hasContribution,
        destinationContributionDetails
    }
});

const requestInProgress = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_PROGRESS
});


const requestPreMotorSuccess = data => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_PRE_MOTOR_SUCCESS,
    payload: {
        data
    }
});

const requestPreMotorFetching = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_PRE_MOTOR_FETCHING,
});

const requestPreMotorFailure = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_PRE_MOTOR_FAILURE,
});

const requestDestinationFundsPostSuccess = ({ data, accounts, hiredFunds }) => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_POST_SUCCESS,
    payload: { data, accounts, hiredFunds }
});

const requestFailure = error => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_FAILURE,
    payload: {
        error
    }
});

const getType = immInternalTransfer => {
    return immInternalTransfer.getIn(['steps', 0, 'type']) === BROKER_REIMBURSE_FUND_TOTAL
        ? 'T'
        : 'P';
};

function storeOrderSummaryRequest() {
    return {
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STORE_ORDER_REQUEST
    };
}

function storeOrderSummarySuccess() {
    return {
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STORE_ORDER_SUCCESS
    };
}

function storeOrderSummaryError() {
    return {
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STORE_ORDER_ERROR
    };
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
            .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
            .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            const disclaimerText = trim(get(disclaimer, 'description'));

            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

const getIntervenersSuccess = data => ({
    type: actionTypes.FETCH_BROKER_GET_INTERVENERS_SUCCESS,
    payload: {
        data
    }
});

const getIntervenersFailure = () => ({
    type: actionTypes.FETCH_BROKER_GET_INTERVENERS_FAILURE,
});

const getHolders = (accountHolder = '', interveners = []) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter(
            intervener => intervener.get('type').trim() == INTERVENER_TYPE_TITULAR
        );
        holderNames = holders.map(holder => holder.get('name').trim());
    } else {
        holderNames.push(accountHolder);
    }
    return holderNames;
}

const getFundById = ({ funds, fundId }) => {
    const cleanFundId = trim(fundId);
    return find(funds, (fund) => trim(get(fund, 'id')) === cleanFundId);
};

const getFundIsin = (fund) => trim(get(fund, 'isin'));

const getAssociatedAccountFromFundId = ({ funds, accounts, fundId }) => {
    const fundById = getFundById({ funds, fundId });
    const fundAssociatedAccountContractNumber = trim(get(fundById, 'associatedAccountContractNumber'));
    const associatedAccount = find(
        accounts,
        (account) => get(account, 'contractNumber') === fundAssociatedAccountContractNumber
    );

    return {
        contractNumber: trim(get(associatedAccount, 'contractNumber')),
        product: trim(get(associatedAccount, 'product'))
    };
};

const getInterveners = () => (dispatch, getState) => {
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const immInternalTransfer = getState().brokerInternalTransferFunds;
    const immAccounts = getState().accounts;

    //Get if is internal (true) or external(false) transfer
    const fundType = immInternalTransfer.getIn(['steps', FIRST_STEP, 'fundType']);
    const isTransferToExistingFund = fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND;

    //Get origin and destination fund Id
    const originFundId = immInternalTransfer.getIn(['steps', FIRST_STEP, 'originFund']);
    const destinationFundId = immInternalTransfer.getIn(['steps', FIRST_STEP, 'destinationFund']);

    //Get all funds
    const funds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).toJS();

    //Get destination fund account
    const destinationFundAssociatedAccount = getAssociatedAccountFromFundId({
        accounts: immAccounts.get('byId').toJS(),
        funds,
        fundId: isTransferToExistingFund ? destinationFundId : originFundId
    });

    const requestData = {
        query: {
            producto: destinationFundAssociatedAccount.product,
            numeroContrato: destinationFundAssociatedAccount.contractNumber
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetIntervenersInvestment'), requestData)
        .then(response => dispatch(getIntervenersSuccess(response)))
        .catch(() => dispatch(getIntervenersFailure()));
};

const storeOrderSummary = (orderResponse) => (dispatch, getState) => {
    const immInvestmentFunds = getState().investmentFunds;
    const immInternalTransfer = getState().brokerInternalTransferFunds;
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const showCost = immFlagBasedFeatures.get('wealth_funds_transfer_show_costs');

    const immProfile = getState().profile;

    const funds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).toJS();

    const fundType = immInternalTransfer.getIn(['steps', FIRST_STEP, 'fundType']);
    const isTransferToExistingFund = fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND;

    const destinationFundId = immInternalTransfer.getIn(['steps', FIRST_STEP, 'destinationFund']);

    const destinationFund = getFundById({ funds, fundId: destinationFundId });
    const destinationFundIsin =
        isTransferToExistingFund ?
        getFundIsin(destinationFund) :
        immInternalTransfer.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']);

    let communicationServiceInput, data;
    const holder = getState().brokerStocksContract.getIn([0, 'walletTitular']);
    const emittedDateTime = moment().format(DATE_FORMAT_WITH_DASHES_DATETIME);
    const shares = (Number(get(orderResponse, 'fondoDestino.participacionesDestino')) || 0).toFixed(BROKER_MIFID_FUNDS_TRANSFER_SHARES_DECIMALS);
    const sharesAmount = (Number(get(orderResponse, 'fondoDestino.precioTotalDestino')) || 0).toFixed(BROKER_MIFID_FUNDS_TRANSFER_AMOUNT_DECIMALS);
    const currency = get(orderResponse, 'fondoDestino.divisaDestino') || '';

    const immBrokerFundLegalDocument =  getState().brokerFundLegalDocument;
    const productKidDocumentUrl = immBrokerFundLegalDocument.get('fundamentalDataForInvesorUrl');
    const marketingReportUrl = immBrokerFundLegalDocument.get('marketingReportsUrl');
    const economicReportUrl = immBrokerFundLegalDocument.get('lastPublishedEconomicReportUrl');
    const interveners = immInternalTransfer.get('interveners');
    const holderNames = getHolders(holder, interveners);

    const immDestFundTransactionCostDocument = immBrokerFundLegalDocument.getIn(['fundTransactionCostDocument', destinationFundIsin]);
    const costYieldObjectId = immDestFundTransactionCostDocument ? immDestFundTransactionCostDocument.get('objectId') : '';
    const exAnteCostList = showCost ? translateExantCostKey(immInternalTransfer.get('exAnteCostList').toJS(), 'brokerInternalTransferFund') : null;
    const isGuaranteedFund = immInternalTransfer.get('isGuaranteedFund');

    communicationServiceInput = {
        email: PersonalDataHelper.getEmail(immProfile),
        productKID: productKidDocumentUrl,
        contract: '',
        marketingReport: marketingReportUrl,
        economicReport: economicReportUrl,
        infoCcv: '',
        originFund: '',
        sendOrder: 'No',
        clientAlias: immProfile.get('nombreCliente'),
        isin: destinationFundIsin,
        isinDescribe: immInvestmentFunds.getIn(['investmentFunds', 'name']),
        idOrder: '',
        channel: CONNECTION_CHANNEL_INTERNET,
        orderType: BROKER_ORDER_TYPE_BUY,
        productType: BROKER_PRODUCT_TYPE_FUNDS_ES,
        holders: holderNames.join(','),
        ccv: immInternalTransfer.getIn(['destinationFund', 'fullContractNumber']),
        idContract: immInternalTransfer.getIn(['destinationFund', 'fullContractNumber']),
        ccc: immInternalTransfer.getIn(['destinationFund', 'associatedAccount']),
        market: '',
        sharesNumber: shares,
        orderCondition: '',
        sharesAmount: sharesAmount,
        termValidity: '',
        conditionPrize: '',
        currency: currency,
        mifidWarningText: generateMiFIDDisclaimers(
            getState().brokerConvenienceMiFIDTest
        ),
        dateTime: emittedDateTime,
        isGuaranteed: isGuaranteedFund,
    };

    const immSteps = getState().brokerInternalTransferFunds.get('steps');
    const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
    const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
    const onlyOriginContribution = originHasContribution && !destinationHasContribution;
    const isContributionStepSkipped = getState().brokerInternalTransferFunds.get('skipContributionStep');

    if (onlyOriginContribution && !isContributionStepSkipped) {
        const firstContributionDate = immSteps.getIn([1, 'selectedDate']);
        communicationServiceInput = {
            ...communicationServiceInput,
            periodicContribution: {
                amount: immSteps.getIn([1, 'amount']),
                currency: immSteps.getIn([1, 'currencyCode']),
                periodicity: PERIODICITY_DOCUMENT_SERVICE[immSteps.getIn([1, 'periodicityValue'])],
                contributionOrderType: "",
                date:  firstContributionDate.format("YYYY-MM-DD")
            }
        };
    }

    if (showCost) {
        communicationServiceInput = {
            ...communicationServiceInput,
            orderType: 'traspaso',
            exAnteCostsList: exAnteCostList,
        };
    } else {
        communicationServiceInput = {
            ...communicationServiceInput,
            costYield: costYieldObjectId,
        };
    }

    data = {
        query: communicationServiceInput,
    };

    dispatch(storeOrderSummaryRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), data)
        .then(
            () => dispatch(storeOrderSummarySuccess()),
            () => dispatch(storeOrderSummaryError())
        );
}

const getTipoUnidadTraspasoByPartialType = (partialType) => {
    const partialTypes = {
        [BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT]: 'I',
        [BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS]: 'P',
        [BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE]: 'C',
    }

    return partialTypes[partialType];
}

const postConfirmation = (dispatch, getState, dataToken, history) => {
    const immInternalTransfer = getState().brokerInternalTransferFunds;
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const immInvestmentFunds = getState().investmentFunds;
    const originFundId  = immInternalTransfer.getIn(['steps', FIRST_STEP, 'originFund']);
    const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
    const selectedOriginFund = funds.find(x => x.get('id') === originFundId);
    const type = getType(immInternalTransfer);
    const amount = immInternalTransfer.getIn(['steps', FIRST_STEP, 'amount']);
    const fundManager = immInvestmentFunds.getIn(['investmentFunds', 'manager']);
    const currency = immBrokerMyInvestments.getIn(['products','funds','currency']);
    const partialType = immInternalTransfer.getIn(['steps', FIRST_STEP, 'partialType']);

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const participacTraspaso = immInternalTransfer.get('participacTraspaso');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation

    let partialQuery = {
        campox: 'T',
        tipoDocumento: __CONTACT_CENTER__ ? 'P' : 'I',
    };

    if (type === 'P') {
        switch (partialType) {
            case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT:
                partialQuery = {
                    campox: 'P',
                    tipoDocumento: 'I'
                };
                break;
            case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS:
                partialQuery = {
                    campox: 'P',
                    tipoDocumento: 'P'
                };
                break;
            case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE:
                partialQuery = {
                    campox: 'P',
                    tipoDocumento: 'C'
                };
                break;
        }
    }

    const query = Object.assign({
        cantidadPorRepartir: amount,
        claveFondoContrOrigen: immInternalTransfer.get('claveFondoContrOrigen'),
        codigoISINOrigen: immInternalTransfer.get('isinFondoOrigen'),
        contador: immInternalTransfer.get('contador'),
        contratoOrigen: {
            numerodecontrato: selectedOriginFund.get('numerodecontrato'),
            producto: selectedOriginFund.get('product')
        },
        ctaAsociada: {
            numerodecontrato: immInternalTransfer.get('ctaAsociada_numerodecontrato'),
            producto: immInternalTransfer.get('ctaAsociada_producto')
        },
        dataToken,
        fechaValor: immInternalTransfer.get('fechaValor'),
        icsaldod: immInternalTransfer.get('icsaldod'),
        importeDispMonedaFondo: {
            divisa: 'EUR',
            importe: 0
        },
        importeTraspaso: {
            divisa: 'EUR',
            importe: 0
        },
        nombreFondoDestino: immInternalTransfer.get('descripcionFondoLarga'),
        participacTraspaso,
        initQuantity: participacTraspaso,
        saldoDia: immInternalTransfer.get('saldoDia'),
        subgrupoCtaAsociada: immInternalTransfer.get('subgrupoCtaAsociada'),
        subtipoContratoDestino: immInternalTransfer.get('subtipoContratoDestino'),
        subtipoContratoOrigen: immInternalTransfer.get('subtipoContratoOrigen'),
        tipodeproductoContratoOrigen: immInternalTransfer.get('tipodeproductoContratoOrigen'),
        tipodeproductoContratoDestino: immInternalTransfer.get('tipodeproductoContratoDestino'),
        tipodeproductoCtaAsociada: immInternalTransfer.get('tipodeproductoCtaAsociada'),
        tipoTraspasoTotalParcial: type,
        ultimoValorLiquidativo: immInternalTransfer.get('ultimoValorLiquidativo'),
        indAltaFondoDest: immInternalTransfer.get('indAltaFondoDest'),
        currency,
        productManager: fundManager,
        reduceRisk: true,
        micCode: '',
        convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
        evaluateRegistry: mifidWasApplied,
        disclaimers: mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
        marketTargetRegistry: mifidScore >= mifidScoring,
        necessaryConvenienceTestNote: mifidScoring,
        necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
        testConveniencyResult: mifidScore,
        uuid: immBrokerLegalDocumentation.get('uuid')
    }, partialQuery);

    const fundType = immInternalTransfer.getIn(['steps', FIRST_STEP, 'fundType']);
    if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
        const destinationFundId  = immInternalTransfer.getIn(['steps', FIRST_STEP, 'destinationFund']);
        const selectedDestinationFund = funds.find(x => x.get('id') === destinationFundId);
        const immInvestmentFund = immInvestmentFunds.get('investmentFunds');
        query.contratoDestino = {
            numerodecontrato: selectedDestinationFund.get('numerodecontrato'),
            producto: selectedDestinationFund.get('product'),
        };
        query.destinationIsin = selectedDestinationFund.get('isin');
        // Get isin from investmentFunds reducer if isin comes null from pg-valores
        if (!query.destinationIsin &&
            immInvestmentFund.get('customInstitutionSecurityId') ===
            selectedDestinationFund.get('customInstitutionSecurityId')
        ) {
            query.destinationIsin = immInvestmentFund.get('isin');
        }
        query.codigoFondoDestino = immInternalTransfer.get('codigoFondo');
    } else {
        query.destinationIsin = immInternalTransfer.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']);
        query.tipoUnidadTraspaso = getTipoUnidadTraspasoByPartialType(partialType);
    }

    const immSteps = getState().brokerInternalTransferFunds.get('steps');
    const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
    const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
    const onlyOriginContribution = originHasContribution && !destinationHasContribution;
    const destinationFundId  = immInternalTransfer.getIn(['steps', FIRST_STEP, 'destinationFund']);
    const selectedDestinationFund = funds.find(x => x.get('id') === destinationFundId);
    const isContributionStepSkipped = getState().brokerInternalTransferFunds.get('skipContributionStep');
    const selectedDate = immSteps.getIn([1, 'selectedDate']);
    const formattedDate = moment(selectedDate).format('DD-MM-YYYY HH:mm:ss.SSSSSS');
    if (onlyOriginContribution && !isContributionStepSkipped) {
        query.recurringTransfer = {
            productId: selectedDestinationFund ? selectedDestinationFund.get('product') : null,
            contractCode: selectedDestinationFund ? selectedDestinationFund.get('numerodecontrato') : null,
            amount: immSteps.getIn([1, 'amount']),
            currencyCode: immSteps.getIn([1, 'currencyCode']),
            subscriptionDate: formattedDate,
            periodicity: immSteps.getIn([1, 'periodicityValue']),
            channel: API_CHANNEL,
            dataToken,
        };
        if (__CONTACT_CENTER__) {
            query.recurringTransfer.openBankInteractionId = usd.getInteractionId();
            query.recurringTransfer.channel = getCCOfficeChannel();
        }
    }

    const postData = {
        header: {
            version: 2,
        },
        query,
    };
    dispatch(requestInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerInternalTransferFundConf'), postData)
        .then(response => {
            const accounts = getState().accounts.get('byId').toJS();
            const hiredFunds = getState().brokerMyInvestments.getIn([
                'products',
                'funds',
                'stocks'
            ]).toJS();

            dispatch(requestDestinationFundsPostSuccess({
                data: response,
                accounts,
                hiredFunds
            }));
            dispatch(storeOrderSummary(response));
        })
        .catch(response => {
            dispatch(requestFailure(response.error));
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const internalTransferConf = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        postConfirmation(dispatch, getState, dataToken, history);
    };
    const isAlreadyFetching = getState().brokerInternalTransferFunds.get('isFetching');

    if (!isAlreadyFetching) {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    }
};

const getPreMotor = (history) => (dispatch, getState) => {
    const immBrokerInternalTransferFunds = getState().brokerInternalTransferFunds;
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const originFundId  = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
    const destinationFundId  = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);
    const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
    const selectedOriginFund = funds.find(x => x.get('id') === originFundId);
    const type = getType(immBrokerInternalTransferFunds);
    const partialType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'partialType']);
    const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
    const contributionAmount = immBrokerInternalTransferFunds.getIn(['steps', SECOND_STEP, 'amount']);
    const contributionCurrency = immBrokerInternalTransferFunds.getIn(['steps', SECOND_STEP, 'currencyCode']);
    const isContributionStepSkipped = immBrokerInternalTransferFunds.get('skipContributionStep');
    const immSteps = getState().brokerInternalTransferFunds.get('steps');
    const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
    const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
    const onlyOriginContribution = originHasContribution && !destinationHasContribution;

    let partialQuery = {
        importePeticion: 0,
        particionesPeticion: 0,
        porcentajeTraspaso: 0,
        tipoUnidadTraspaso: getTipoUnidadTraspasoByPartialType(partialType),
    };

    switch (partialType) {
        case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT:
            partialQuery.importePeticion = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'amount']);
            break;
        case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS:
            partialQuery.particionesPeticion = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'participations']);
            break;
        case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE:
            partialQuery.porcentajeTraspaso = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'percentage']);
            break;
        default:
            partialQuery = {};
    }

    let destinationIsin;
    if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
        const selectedDestinationFund = funds.find(x => x.get('id') === destinationFundId);
        partialQuery = Object.assign({
            numeroContratoDestino: selectedDestinationFund.get('numerodecontrato'),
            productoDestino: selectedDestinationFund.get('product'),
        }, partialQuery);
        destinationIsin = selectedDestinationFund.get('isin');
    } else {
        destinationIsin = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']);
    }

    const showCost = immFlagBasedFeatures.get('wealth_funds_transfer_show_costs');
    const header = showCost ? {
        version: 2,
    } : null;
    const requestData = {
        header: header,
        query: Object.assign({
            producto: selectedOriginFund.get('product'),
            numeroContrato: selectedOriginFund.get('numerodecontrato'),
            numeroEmpleado: BROKER_EMPLOYEE_ID,
            tipoTraspasoTotalParcial: type,
            isin: destinationIsin,
        }, partialQuery)
    };


    const requestCostsData = {
        header: {
            version: 2
        },
        query: {
            importe: {
                amount: 0,
                currency: contributionCurrency
            },
            isin: destinationIsin,
            recurringTransferAmount: {
                amount: contributionAmount,
                currency: contributionCurrency
            }
        }
    };

    dispatch(requestInProgress());
    dispatch(requestPreMotorFetching());
    const costsRequest = [
        APIPost(
            dispatch,
            apiURLBuilder.getURL("brokerInternalTransferFundStep2"),
            requestData
        )
    ]


    if (!isContributionStepSkipped && onlyOriginContribution ) {
        const contributionCostsRequest = APIPost(dispatch, apiURLBuilder.getURL('brokerBuyFundsExtantCosts'), requestCostsData)
        costsRequest?.push(contributionCostsRequest)
    }

    return showCost
        ? Promise.all(costsRequest)
            .then((response) => {
                const recurringTransferSellCosts =  response[1]?.response.find((item)=> item.descriptionKey === 'potentialSellFundsCosts');
                if (recurringTransferSellCosts && onlyOriginContribution && !isContributionStepSkipped) {
                    const exAnteCostListWithContribution = response[0]?.exAnteCostList?.map((item) => {
                        if (item.descriptionKey === 'potentialSellFundsCosts') {
                            return recurringTransferSellCosts;
                        }
                        return item
                    });
                        response[0].exAnteCostList = exAnteCostListWithContribution
                };
                return dispatch(requestPreMotorSuccess({...response[0], ...{recurringTransferCosts: recurringTransferSellCosts || {}}}))
            })
            .catch((response) => {
                dispatch(requestFailure(response.error));
                const errorKey = get(response, ["body", "error"], "");
                dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
                dispatch(requestPreMotorFailure());
            })
        : APIGet(
            dispatch,
            apiURLBuilder.getURL("brokerInternalTransferFundStep2"),
            requestData
        )
            .then((response) => dispatch(requestPreMotorSuccess(response)))
            .catch((response) => {
                dispatch(requestFailure(response.error));
                const errorKey = get(response, ["body", "error"], "");
                dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
                dispatch(requestPreMotorFailure());
            });
};


const validateDestinationFundDocumentsRequest = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_VALIDATE_DOCUMENTS_REQUEST
});

const validateDestinationFundDocumentsSuccess = enableEconomicReport => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_VALIDATE_DOCUMENTS_SUCCESS,
    payload: {
        enableEconomicReport
    }
});

const validateDestinationFundDocumentsFailure = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_VALIDATE_DOCUMENTS_FAILURE
});

const validateDestinationFundDocuments = (mustControlEconomicReport, history) => (dispatch, getState) => {
    const immBrokerInternalTransferFunds = getState().brokerInternalTransferFunds;
    const immBrokerMyInvestments = getState().brokerMyInvestments;

    const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
    const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
    const destinationFundId  = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);


    let isin;
    if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
        const selectedDestinationFund = funds.find(x => x.get('id') === destinationFundId);
        isin = selectedDestinationFund.get('isin');
    } else {
        isin = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']);
    }
    dispatch(validateDestinationFundDocumentsRequest());

    const immProfile = getState().profile;
    const originCountry = immProfile.get('originCountry')
    const immGlobalVariables = getState().globalVariables;
    const memories = immGlobalVariables.getIn(['variables', 'parameters', 'memories', 'memories']);
    let publicSiteUrl = apiURLBuilder.getPublicSiteUrl(false);
    if (!!publicSiteUrl && publicSiteUrl.slice(publicSiteUrl.length - 3, -2) === "/") {
        publicSiteUrl = publicSiteUrl.slice(0, -3);
    }
    const dfi = apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: isin, documentType: 'DFI', originCountry: originCountry})
    const mc = memories
        ? `${publicSiteUrl}${memories.trim()}${isin}.pdf?originCountry=${originCountry}`
        : '';
    const mustShowMC = showMemories(originCountry , isin)

    if(!!dfi && (!mustShowMC || (!!mc ))) {
        let arrayPromises = [APIGet(dispatch, dfi, {})];
        if (mustShowMC) {
            arrayPromises.push(APIGet(dispatch, dfi, {}))
        }

        if (originCountry === PT) {
            const prospectus = apiURLBuilder.getURL('morningstarFundDocumentPDF', { isin: isin, documentType: 'Prospectus', originCountry: originCountry })
            const anual = apiURLBuilder.getURL('morningstarFundDocumentPDF', { isin: isin, documentType: 'Anual', originCountry: originCountry })
            arrayPromises.push(APIGet(dispatch, prospectus, {}))
            arrayPromises.push(APIGet(dispatch, anual, {}))
        }

        Promise.all(arrayPromises)
            .then(() => {
                const ies = apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: isin, documentType: 'InformeSemestral', originCountry: originCountry});
                return APIGet(dispatch, ies, {})
                    .then(() => {
                        dispatch(validateDestinationFundDocumentsSuccess(true));
                    }).catch(() => {
                        if (mustControlEconomicReport) {
                            dispatch(errorActions.show('', true, history));
                            dispatch(validateDestinationFundDocumentsFailure());
                        } else {
                            dispatch(validateDestinationFundDocumentsSuccess(false));
                        }
                    })
            }).catch(() => {
                dispatch(errorActions.show('', true, history));
                dispatch(validateDestinationFundDocumentsFailure());
            })
    } else {
        dispatch(errorActions.show('', true, history));
        dispatch(validateDestinationFundDocumentsFailure());
    }

};

const validateEconomicReport = (history) => (dispatch, getState) => {
    const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;
    const immInvestmentFunds = getState().investmentFunds;

    const requestData = {
            query: {
                viewId: 'fullNew',
                responseViewFormat: 'json'
            }
    }

    const secId = !!immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds'])
        ? immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'secId'])
        : null;

    dispatch(validateDestinationFundDocumentsRequest());


    return APIGet(
            dispatch,
            apiURLBuilder.getURL(
                'brokerGetMorningStarScreenerSecurityDetails',
                {
                    type: typeId,
                    id: secId,
                }
            ),
            requestData
        )
        .then((response) => {
            const mustControlEconomicReport = !!response[0] && !!response[0].InceptionDate ?
                moment(response[0].InceptionDate).isBefore(moment().subtract(1, 'year')) : false;
            dispatch(validateDestinationFundDocuments(mustControlEconomicReport, history));
        }).catch(() => {
            dispatch(errorActions.show('', true, history));
            dispatch(validateDestinationFundDocumentsFailure());
        });
}

const preSelectOrigin = (fundId, hasContribution, contributionDetails) => dispatch => {
    dispatch(setOriginFund(fundId, undefined, hasContribution, contributionDetails));
};

const reset = () => dispatch =>
    dispatch({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_RESET,
        payload: {}
    });

const toggleDisclaimer = () => dispatch =>
    dispatch({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_TOGGLE_DISCLAIMER,
        payload: {}
    });

const legalYesNoOptionChange = option => ({
    type: contactCenterActionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_LEGAL_YES_NO_OPTION_CHANGE,
    payload: {
        option
    }
});

const resetLegalInformation = () => ({
    type: contactCenterActionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_LEGAL_INFORMATION_RESET
});

const continueInternalTransferFundFromMifid = (
    originFund,
    destinationFund,
    mifidId,
    displayMifidDisclaimer
) => (dispatch, getState) => {
    const immFunds = getState().brokerMyInvestments.getIn(['products', 'funds', 'stocks']);
    const immFund = immFunds.find(immFund => immFund.get('id') === originFund);
    const originFundCurrency = immFund ? immFund.get('quoteCurrency') : EURO_TEXT;
    const immDestinationFund = immFunds.find(immFund => immFund.get('id') === destinationFund);
    const contributionMinimumAmount = immDestinationFund ? immDestinationFund.get('customAdditionalMinimumAmount') : null;
    const contributionCurrency = immDestinationFund ? immDestinationFund.get('quoteCurrency') : EURO_TEXT;
    dispatch({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STEP_SELECT_FUNDS_SUCCESS,
        payload: { originFund, originFundCurrency, destinationFund, mifidId, displayMifidDisclaimer, contributionMinimumAmount, contributionCurrency }
    });
};

const stepSelectFundsValidation = (history, verify = true) => (dispatch, getState) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STEP_SELECT_FUNDS_VALIDATE,
        payload: {}
    });
    const immInternalTransfer = getState().brokerInternalTransferFunds;
    const originFundValid = immInternalTransfer.getIn(['steps', FIRST_STEP, 'originFundValid']);
    const destinationFundValid = immInternalTransfer.getIn(['steps', FIRST_STEP, 'destinationFundValid']);
    const newFundSelectedValid = immInternalTransfer.getIn(['steps', FIRST_STEP, 'newFundSelectedValid']);
    const fundType = immInternalTransfer.getIn(['steps', FIRST_STEP, 'fundType']);

    if (!originFundValid) {
        return;
    }

    if (immInternalTransfer.get('stepSelectFundsLoading')) {
        return;
    }

    let destinationFundId;
    if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
        if (!destinationFundValid) {
            return;
        }
        const immBrokerMyInvestments = getState().brokerMyInvestments;
        const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);

        const selectedDestinationFund = immInternalTransfer.getIn(['steps', FIRST_STEP, 'destinationFund']);

        const immDestinationFund = immFunds.find(
            immFund => immFund.get('id') === selectedDestinationFund
        );

        if (!immDestinationFund) {
            dispatch(errorActions.show('', true, history));
            return;
        }
        destinationFundId = immDestinationFund.get('customInstitutionSecurityId');
    } else if (fundType === BROKER_INTERNAL_TRANSFER_NEW_FUND) {
        if (!newFundSelectedValid) {
            return;
        }

        if(verify) {
            const immBrokerMyInvestments = getState().brokerMyInvestments;
            const selectedNewFundISIN = immInternalTransfer.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']);
            const destinationFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks'])
            const exitsInDestinationFund = destinationFunds.find(fund => fund.get("isin") === selectedNewFundISIN && fund.get("interventionType") === ACCOUNT_INTERVENTION_OWNER)
            if(!!exitsInDestinationFund) {
                dispatch({
                    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STEP_SELECT_FUNDS_SHOW_MODAL,
                    payload: { selectedNewFundISIN }
                });
                return
            }
        }

        destinationFundId = immInternalTransfer.getIn(['steps', FIRST_STEP, 'selectedNewFund']);
    }

    dispatch({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STEP_SELECT_FUNDS_LOADING,
        payload: {}
    });

    const fetchingFundData = dispatch(investmentFundsActions.getMorningStarScreener(destinationFundId));
    if (fetchingFundData) {
        fetchingFundData.catch(
            () => dispatch(errorActions.show('', true, history))
        );
    }
};

const onChangeFundType = type => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_FUND_TYPE,
    payload: {
        type
    }
});

const hideModalSelectFunds = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_STEP_SELECT_FUNDS_HIDE_MODAL,
    payload: {}
});

const inputSearchFundSelected = product => {
    return {
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_NEW_FUND_SELECTED,
        payload: {
            product
        }
    };
};

const setEmptyState = (history) => dispatch => {
    dispatch(errorActions.show('', true, history))
}

const setOriginContributionFundStep = (contributionData) => dispatch => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_INITIAL_ORIGIN_CONTRIBUTION_STEP,
        payload: {
            contributionData
        }
    });
}

const setContributionDatePickerError = (error) => {
    return {
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_CONTRIBUTION_DATEPICKER_ERROR,
        payload: {
            isValidDate: false
        }
    }
}

const setPreviousContributions = ({amount, periodicityValue, periodicityLabel, nextInstallmentDate, subscriptionDateId}) => {
    return ({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_PREVIOUS_CONTRIBUTION_DATA,
        payload: {
            amount,
            periodicityValue,
            periodicityLabel,
            nextInstallmentDate,
            subscriptionDateId,
            hasPreviousContributions: true
        }
    })
};

const setContributionAmount = amount => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_CONTRIBUTION_AMOUNT,
    payload: {
        amount
    }
});

const validateContributionStep = step => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_CHANGE_CONTRIBUTION_VALIDATE_STEP,
    payload: {
        step
    }
});

const setContributionPeriodicity = (value) => {
    return ({
        type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_CONTRIBUTION_PERIODICITY,
        payload: {
            value: value.value,
            label: value.label,
        }
    })
};

const setContributionValidityDateValue = date => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_CONTRIBUTION_DATE_VALUE,
    payload: {
        date
    }
});

const setContributionAccountNumber = (accountId, accountAmount, linkedToRobo) => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_CONTRIBUTION_ACCOUNT_NUMBER,
    payload: {
        accountId,
        accountAmount,
        linkedToRobo,
    }
});

const skipContributionStep = (state) => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SKIP_CONTRIBUTION_STEP,
    payload: {state}
});
const removeContributionStep = () => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_REMOVE_ORIGIN_CONTRIBUTION_STEP
});

module.exports = {
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    setAmount,
    setAproxAmountParticipations,
    validateStep,
    internalTransferConf,
    changeType,
    changeReadChecked,
    setPartialTransferType,
    setOriginFund,
    getPreMotor,
    setDestinationFund,
    preSelectOrigin,
    reset,
    toggleDisclaimer,
    stepSelectFundsValidation,
    continueInternalTransferFundFromMifid,
    inputSearchFundSelected,
    onChangeFundType,
    legalYesNoOptionChange,
    resetLegalInformation,
    getInterveners,
    setEmptyState,
    hideModalSelectFunds,
    validateDestinationFundDocuments,
    validateEconomicReport,
    setOriginContributionFundStep,
    setContributionAmount,
    validateContributionStep,
    setContributionPeriodicity,
    setContributionValidityDateValue,
    setContributionAccountNumber,
    setPreviousContributions,
    setContributionDatePickerError,
    skipContributionStep
};
